import { Card, CardContent } from "@/components/ui-lab/card"
import { MdLocationOn } from "react-icons/md"
import { OfflineAwareMap } from "../OfflineAwareMap"

export const MyLocation = () => {
  return (
    <div className="mt-8">
      <Card className="shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">
        <CardContent className="p-6">
          <h2 className="text-xl font-semibold mb-4 flex flex-row gap-2 items-center" suppressHydrationWarning>
            <MdLocationOn className="mr-2" />
            Find Me Here
          </h2>
          <div className="relative w-full h-[400px] rounded-lg overflow-hidden">
            <OfflineAwareMap
              src="https://maps.google.com/maps?q=27.675979873845655,85.41927514457923&t=&z=15&ie=UTF8&iwloc=&output=embed"
              title="Location Map"
              className="w-full h-full"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
